function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1694",
  "data-name": "Group 1694",
  transform: "translate(-89.191 -216.938)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1670",
  "data-name": "Group 1670",
  transform: "translate(0.191 -1.311)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Component_34_26",
  "data-name": "Component 34 \\u2013 26",
  transform: "translate(200.408 254.715) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_864",
  "data-name": "Group 864",
  transform: "translate(-1321 -958.105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_767",
  "data-name": "Group 767",
  transform: "translate(1411 1178.105)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_637",
  "data-name": "Path 637",
  d: "M8.776-27.5v9.59",
  transform: "translate(-0.857 70.886)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_638",
  "data-name": "Path 638",
  d: "M16.277-22.79v4.8",
  transform: "translate(-0.72 70.973)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_639",
  "data-name": "Path 639",
  d: "M6.354-18.082H18.675v1.023H6.354Z",
  transform: "translate(-0.902 71.059)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_640",
  "data-name": "Path 640",
  d: "M42.2-27.5v9.59",
  transform: "translate(-0.244 70.886)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_641",
  "data-name": "Path 641",
  d: "M34.7-22.79v4.8",
  transform: "translate(-0.382 70.973)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_642",
  "data-name": "Path 642",
  d: "M32.519-18.078H44.84v1.018H32.519Z",
  transform: "translate(-0.421 71.06)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_631",
  "data-name": "Path 631",
  d: "M25.836-70.1A24.847,24.847,0,0,1,50.671-45.269,24.847,24.847,0,0,1,25.836-20.433,24.847,24.847,0,0,1,1-45.269,24.847,24.847,0,0,1,25.836-70.1Z",
  transform: "translate(-1 70.104)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_632",
  "data-name": "Path 632",
  d: "M25.734-64.558A19.2,19.2,0,0,1,44.921-45.37,19.2,19.2,0,0,1,25.734-26.183,19.2,19.2,0,0,1,6.547-45.37,19.2,19.2,0,0,1,25.734-64.558Z",
  transform: "translate(-0.898 70.206)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_643",
  "data-name": "Path 643",
  d: "M25.437-48.413a2.748,2.748,0,0,1,2.746,2.746,2.748,2.748,0,0,1-2.746,2.746,2.748,2.748,0,0,1-2.746-2.746A2.748,2.748,0,0,1,25.437-48.413Z",
  transform: "translate(-0.602 70.502)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_644",
  "data-name": "Path 644",
  d: "M7.66-45.716h4.389",
  transform: "translate(-0.878 70.552)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_645",
  "data-name": "Path 645",
  d: "M8.725-51.769l4.126,1.5",
  transform: "translate(-0.858 70.441)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_646",
  "data-name": "Path 646",
  d: "M11.793-57.094l3.366,2.817",
  transform: "translate(-0.802 70.343)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_647",
  "data-name": "Path 647",
  d: "M16.494-61.052l2.2,3.8",
  transform: "translate(-0.716 70.27)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_648",
  "data-name": "Path 648",
  d: "M22.263-63.167l.774,4.321",
  transform: "translate(-0.61 70.232)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_649",
  "data-name": "Path 649",
  d: "M28.422-63.185l-.748,4.325",
  transform: "translate(-0.51 70.231)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_636",
  "data-name": "Path 636",
  d: "M34.23-61.1l-2.18,3.81",
  transform: "translate(-0.43 70.27)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_635",
  "data-name": "Path 635",
  d: "M38.976-57.174l-3.349,2.837",
  transform: "translate(-0.364 70.342)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_633",
  "data-name": "Path 633",
  d: "M42.089-51.868l-4.117,1.523",
  transform: "translate(-0.321 70.439)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_634",
  "data-name": "Path 634",
  d: "M43.195-45.822l-4.389.026",
  transform: "translate(-0.306 70.55)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_650",
  "data-name": "Path 650",
  d: "M32.773-53,27.291-47.52",
  transform: "translate(-0.517 70.418)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_651",
  "data-name": "Path 651",
  d: "M23.585-43.814,18.1-38.331",
  transform: "translate(-0.686 70.587)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_652",
  "data-name": "Path 652",
  d: "M21.636-34.364h2.543v-2.543H21.636Z",
  transform: "translate(-0.621 70.714)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_653",
  "data-name": "Path 653",
  d: "M26.647-34.364H29.19v-2.543H26.647Z",
  transform: "translate(-0.529 70.714)",
  fillRule: "evenodd"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1667",
  "data-name": "Group 1667",
  transform: "translate(75.682 -121.344)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678",
  "data-name": "Group 678",
  transform: "translate(168 340.592)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_486",
  "data-name": "Path 486",
  d: "M252.959-165.605c0-3.1-2.949-5.613-6.584-5.613H218.608c-3.634,0-6.584,2.515-6.584,5.613V-129.7c0,3.1,2.95,5.613,6.584,5.613h27.767c3.635,0,6.584-2.515,6.584-5.613Z",
  transform: "translate(-212.024 177.654)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489",
  "data-name": "Path 489",
  d: "M220.819-172.117H246.1v-6.333H220.819Z",
  transform: "translate(-212.992 178.45)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  "data-name": "Path 492",
  d: "M220.819-115.221H246.1v-1.585H220.819Z",
  transform: "translate(-212.992 171.284)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  "data-name": "Path 495",
  d: "M212.168-162.192h40.68",
  transform: "translate(-212.04 176.563)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498",
  "data-name": "Path 498",
  d: "M212.168-127.273h40.68",
  transform: "translate(-212.04 172.437)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_517",
  "data-name": "Path 517",
  d: "M232.159-149.994s4.449,6.844,4.449,9.3a4.451,4.451,0,0,1-4.449,4.449,4.452,4.452,0,0,1-4.45-4.449C227.709-143.15,232.159-149.994,232.159-149.994Z",
  transform: "translate(-43.691 514.129)",
  fill: "#48b05e",
  fillRule: "evenodd"
}))));

var SvgAnalyzerResult = function SvgAnalyzerResult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196.617,
    height: 58.063,
    viewBox: "0 0 196.617 58.063",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalyzerResult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analyzer-result.1ab7465c.svg";
export { ForwardRef as ReactComponent };